// extracted by mini-css-extract-plugin
export default {"rating":"oC-z","numberOfStars":"pC-z","count":"qC-z","barGraphSpacing":"rC-z","barGraph":"sC-z"};